import axios from "axios";
import config from "../config";

const baseURL = config.apiBaseUrl;

export const getUserReservation = () => {
  const headers = {
    Authorization: `Bearer ${localStorage.getItem("token")}`,
  };

  return axios.get(baseURL + "/api/bookings/my-reservations", {
    headers,
  });
};
